import { useContext, useEffect, useState } from "react";
import { PrintDataContext, SetPrintDataContext } from "../../../Pages";
import DynaTable from "../../MyTable/DynaTable";
import Loader from "../../Loader";
import { useNavigate } from "react-router-dom";
import utilsFunction from "../../../utils/utilsFunction";
import {exportXLSXFile} from "../../../utils/exportCSVFile";
const LedgerTable = () => {
  const data = useContext(PrintDataContext);
  const setTableData = useContext(SetPrintDataContext);
  const navigate = useNavigate();

  // for(i=0,j=16 ;i<(data.data.length-17),i=i+17,j=j+16){
  //   let sumData=data.data.slice(i,j)
  // }

  const [result, setResult] = useState([]);
  let pure = data.data;
  useEffect(() => {
    // Calculate the sum of every 18 indexes for 'bed' and push as the 19th index
    pure.unshift({
      bed: "0",
      description: "منقول از صفحه قبل",
      bes: "0",

      documentCode: "",
      accountName: "",
      accountCode: "",
      date: "",
    });
    console.log(pure);
    // if (pure[i]["accountName"] === pure[i - 1]["accountName"])

    let sumBed = 0,
      sumBes = 0;
    if (data.title === "general") {
      let state = false;
      let y = 0;
      for (let i = 0; i < pure.length; i++) {
        const element = pure[i];
        if (y > 0) {
          y = y + 1;
        }
        if (i % 21 === 0 && i !== 0 && i < 22) {
          const varTop = {
            bed: sumBed.toString(),
            description: "منقول به صفحه بعد",
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
          };
          const varBot = {
            bed: sumBed.toString(),
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
            description: "منقول از صفحه قبل",
          };
          // if (pure[i]["accountName"] === pure[i - 1]["accountName"])
          setResult((prevArray) => [...prevArray, varTop]);
          setResult((prevArray) => [...prevArray, varBot]);
          setResult((prevArray) => [...prevArray, element]);
          sumBed += +element.bed;
          sumBes += +element.bes;
        } else if (i !== 0 && y % 20 === 0 && state) {
          setResult((prevArray) => [...prevArray, element]);
          sumBed += +element.bed;
          sumBes += +element.bes;
          const varTop = {
            bed: sumBed.toString(),
            description: "منقول به صفحه بعد",
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
          };
          const varBot = {
            bed: sumBed.toString(),
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
            description: "منقول از صفحه قبل",
          };
          setResult((prevArray) => [...prevArray, varTop]);
          setResult((prevArray) => [...prevArray, varBot]);
        } else if (
          i !== 0 &&
          i % 20 === 0 &&
          !state &&
          pure[i]["accountName"] === pure[i - 1]["accountName"] &&
          i > 22
        ) {
          setResult((prevArray) => [...prevArray, element]);
          sumBed += +element.bed;
          sumBes += +element.bes;
          const varTop = {
            bed: sumBed.toString(),
            description: "منقول به صفحه بعد",
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
          };
          const varBot = {
            bed: sumBed.toString(),
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
            description: "منقول از صفحه قبل",
          };
          setResult((prevArray) => [...prevArray, varTop]);
          setResult((prevArray) => [...prevArray, varBot]);
        } else if (
          i !== 0 &&
          i > 22 &&
          pure[i]["accountName"] !== pure[i - 1]["accountName"] &&
          pure[i]["accountName"] !== "" &&
          pure[i - 1]["accountName"] !== ""
        ) {
          state = true;
          y = 1;
          sumBed += +element.bed;
          sumBes += +element.bes;
          const varTop = {
            bed: sumBed.toString(),
            description: "منقول به صفحه بعد",
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
          };
          const varBot = {
            bed: sumBed.toString(),
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
            description: "منقول از صفحه قبل",
          };
          setResult((prevArray) => [...prevArray, varTop]);
          setResult((prevArray) => [...prevArray, varBot]);
          setResult((prevArray) => [...prevArray, element]);
        } else {
          sumBed += +element.bed;
          sumBes += +element.bes;
          setResult((prevArray) => [...prevArray, element]);
        }
      }
    } else {
      for (let i = 0; i < pure.length; i++) {
        const element = pure[i];

        if (i % 21 === 0 && i !== 0 && i < 22) {
          const varTop = {
            bed: sumBed.toString(),
            description: "منقول به صفحه بعد",
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
          };
          const varBot = {
            bed: sumBed.toString(),
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
            description: "منقول از صفحه قبل",
          };
          setResult((prevArray) => [...prevArray, varTop]);
          setResult((prevArray) => [...prevArray, varBot]);
          setResult((prevArray) => [...prevArray, element]);
          sumBed += +element.bed;
          sumBes += +element.bes;
        } else if (i % 20 === 0 && i !== 0 && i > 22) {
          setResult((prevArray) => [...prevArray, element]);
          sumBed += +element.bed;
          sumBes += +element.bes;
          const varTop = {
            bed: sumBed.toString(),
            description: "منقول به صفحه بعد",
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
          };
          const varBot = {
            bed: sumBed.toString(),
            bes: sumBes.toString(),
            documentCode: "",
            accountName: "",
            accountCode: "",
            date: "",
            description: "منقول از صفحه قبل",
          };
          setResult((prevArray) => [...prevArray, varTop]);
          setResult((prevArray) => [...prevArray, varBot]);
        } else {
          sumBed += +element.bed;
          sumBes += +element.bes;
          setResult((prevArray) => [...prevArray, element]);
        }
      }
    }

    console.log(pure);
    console.log(result);
  }, [pure]);
  const printLedgerHandler = () => {
    data.data = result;
    data.type = "ledger";
    setTableData(data);
    navigate("/factorprint");
  };

  const letGoXLS = () => {

    const format = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const fileName =
      "اکسل" + new Date().toLocaleDateString("fa-ir", format);
    const normalizeData = utilsFunction.convertTabulatorDataToJson(data?.column, data.data)
    //exportCSVFile(normalizeData, fileName, "")
    exportXLSXFile(normalizeData, fileName, "")

  }

  return (
    <div>
      <button className="btn" onClick={printLedgerHandler}>
        پرینت
      </button>

      <button className="btn" onClick={letGoXLS}>
        اکسل
      </button>

      {result.length > 0 && data ? (
        <>
          <DynaTable
            column={data?.column}
            data={result}
            priceFields={data?.priceFields}
            className={"solid-table"}
            mainWidth={"100%"}
          />
        </>
      ) : (
        //  onRowClick={rowClickHandler}
        <Loader />
      )}
    </div>
  );
};

export default LedgerTable;
